export const QueryKeys = {
  Profile: "profile",
  Organization: "organization",
  PaymentInfo: "payment-info",
  JobsList: "jobs-list",
  Dashboard: "dashboard-data",
  Job: "job",
  JobReport: "job-report",
  JobsConfig: "jobs-config",
  AdditionalNotes: "additional-notes",
  QuotesList: "quotes-list",
  QuoteDetails: "quote-details",
};
